import React from "react";

interface EmailTemplateProps {
  buttonColor?: string;
  linkUrl: string;
  companyName: string;
  clientName: string;
}

const EmailTemplate: React.FC<EmailTemplateProps> = ({
  buttonColor = "var(--color-ui-action)",
  linkUrl,
  companyName,
  clientName,
}) => {
  // required because scss doesn't copy to clipboard
  const requestButtonStyle = {
    color: "white",
    fontWeight: "700",
    borderRadius: "4px",
    margin: "2px 1px",
    textDecoration: "none",
    padding: "7px 10px",
    display: "inline-block",
    backgroundColor: buttonColor,
  };

  const noMargin = {
    margin: "0",
  };

  return (
    <div id="email-template">
      <p>Dear {companyName},</p>
      <p>
        As per our discussion, I am sending you this email requesting you to
        submit your suppliers&apos; information using a secure onboarding
        portal. To do this, you will be asked to log in to your accounting or
        ERP software. Your login details will not be shared with anyone at any
        point. As part of the registration process, you will see important Terms
        & Conditions regarding this service.
      </p>
      <p>
        When you complete the request, you will share the following data which
        we will be able to view:
      </p>
      <ul>
        <li>
          Your company&apos;s basic details, including its address and contact
          details
        </li>
        <li>
          Your suppliers&apos; basic details, including their address and
          contact details
        </li>
        <li>
          Details of your transactions with these suppliers (payment methods,
          bill and payment amounts, payment terms)
        </li>
      </ul>
      <p>We will use this information to prepare your card program offer.</p>
      <p>
        When you are ready to provide your supplier information, click the
        button below to begin.
      </p>
      <p>
        <a
          style={requestButtonStyle}
          href={linkUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="complete-information-button"
        >
          Complete information request
        </a>
      </p>
      <p>{linkUrl}</p>
      <p>
        Please let me know if you have any questions or would like to know more.
      </p>
      <p style={noMargin}>
        <b>Revoking Access</b>
      </p>
      <p style={noMargin}>
        You have control of your information and can revoke {clientName}&apos;s
        access at any time by either:
      </p>
      <p style={noMargin}>
        1. Removing access directly in your ERP/accounting software app
        management page.
      </p>
      <p style={noMargin}>OR</p>
      <p style={noMargin}>2. Contact me about revoking access.</p>
      <hr />
      <p>
        <b>{clientName}</b> trusts <b>Codat Inc</b> to securely retrieve
        financial information from their customers. <b>Codat Inc</b> is a
        specialized data infrastructure provider, incorporated in Delaware with
        a registered address of 331 Park Ave South, 4th Floor, New York, NY
        10010, United States.
      </p>
    </div>
  );
};

export default EmailTemplate;
